document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.store-card .store-card__page-link').forEach(function (anchor) {
        anchor.addEventListener('click', function (e) {
            // Find the nearest .store-card container
            var parentCard = anchor.closest('.store-card');
            if (parentCard && parentCard.classList.contains('style1')) {
                e.preventDefault();
                parentCard.classList.toggle('active');

                // Remove 'active' class from .store-card siblings inside .flickity-slider
                var flickitySlider = parentCard.closest('.flickity-slider');
                if (flickitySlider) {
                    flickitySlider.querySelectorAll('.store-card').forEach(function (sibling) {
                        if (sibling !== parentCard) {
                            sibling.classList.remove('active');
                        }
                    });
                }
            }
        });
    });
});